Ext.ns('mx.comp');

mx.comp.AccountHostsList = Ext.extend(mx.comp.ListField, {
    valueFieldWidth: 0,
    valueFieldShift: 0,
    padding: 5,

    clsListValue: 'maxoptra-comp-list-value-empty',
    textConfig: {},
    adjustedValueFieldWidth: 0,
    createValueField: function(config) {
        return new Ext.Panel({
            border: false,
            height: 16,
            setValue: Ext.emptyFn,
            getValue: function() {
                return 'HOST';
            },
        });
    },
    initComponent: function() {
        Ext.apply(this.textConfig, {
            listeners: {
                keypress: this.onKeyPress,
                scope: this,
            },
        });
        mx.comp.AccountHostsList.superclass.initComponent.apply(this, arguments);
    },
    onKeyPress: function(textField, e) {
        this.addEmptyRow();
        textField.un('change', this.onKeyPress, this);
        textField.un('keypress', this.onKeyPress, this);
    },
    _checkControls: function(ctrl) {
        var res = true;
        if (!ctrl[0].getValue()) {
            ctrl[0].markInvalid();
            res = false;
        }
        if (ctrl[2] && ctrl[2].isVisible()) {
            if (res && !ctrl[1].getValue()) {
                ctrl[1].markInvalid();
                res = false;
            }
            if (res && !ctrl[1].validateValue(ctrl[1].getValue())) {
                res = false;
            }
        }
        return res;
    },
});

Ext.reg('mx-accounthostslist', mx.comp.AccountHostsList);
